import Moment from 'moment'
/**
 * 将数字转为中文小写
 * @param {number} num - 要转的数字
 * @return {string} 输出的中文汉字
 */
export const changeChineseNum = (num: number): any => {
  // let isNumber = (aaa: number) => {
  //   try {
  //     parseInt(String(aaa), 10)
  //     return true
  //   }
  //   catch (err) {
  //     return false
  //   }
  // }

  let CnNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
  let ShiNum = ['千', '', '十', '百']
  let WanNum = ['', '万', '亿']
  let NumTh = ''
  let OutCn = ''

  let Zero = false
  let Wan = false
  let Hand = true
  // zero 为是否需要输出汉字“零”，Wan为首否需要输出汉字“万”或“亿”，Hand 判断是否为第一个非零数字。

  let Numlan
  let NumTemp
  let Booltemp

  // if (isNumber(num)) {
  NumTemp = parseInt(String(num), 10)
  Numlan = NumTemp.toString().length
  // }
  // else {
  //   NumTemp = 0
  //   Numlan = 0
  // }
  for (let i = 1; i <= Numlan; i++) {
    NumTh = num.toString().substring(i - 1, i)
    let NowNum
    let NowTh = Numlan + 1 - i
    NowNum = parseInt(NumTh, 10)
    // if (isNumber(Number(NumTh))) {
    //   NowNum = parseInt(NumTh, 10)
    //   // OutCn = OutCn + CnNum[i];
    // }
    // else {
    //   break
    // }

    if (NowNum === 0) {
      if (Hand) {
        continue
      }
      else {
        Zero = true
      }
    }
    else {
      Wan = true
      if (Hand) {
        if (NumTemp > 9 && NumTemp < 20) {
          OutCn = OutCn + ShiNum[NowTh % 4]
        }
        else {
          OutCn = OutCn + CnNum[NowNum] + ShiNum[NowTh % 4]
        }

        Hand = false
      }
      else {
        if (!Zero) {
          OutCn = OutCn + CnNum[NowNum] + ShiNum[NowTh % 4]
        }
        else {
          OutCn = OutCn + CnNum[0] + CnNum[NowNum] + ShiNum[NowTh % 4]
          Zero = false
        }
      }
    }
    if (Wan && (NowTh - 1) % 4 === 0) {
      OutCn = OutCn + WanNum[((NowTh - 1) / 4) % 2]
      for (let j = parseInt(String((NowTh - 1) / 8), 10); j > 0; j = j - 1) {
        OutCn = OutCn + WanNum[2]
      }
      Wan = false
    }
  }
  return OutCn
  // if (isNumber(Number(NumTh))) {

  // }
  // else {
  //   return '包含非阿拉伯字符！请更正！'
  // }
}

/**
 * 重组数据源，一维数组变成二维数组
 * [{},{},{}]=>[[{},{}],[{}]]
 * params {array} targetArr  需要重组的数据
 * params {number} num 二维数组里面的数据个数
 * return newArr 新数组
 */
export const packageRecmdData = (targetArr: object[], num: number): any[] => {
  targetArr = JSON.parse(JSON.stringify(targetArr))
  const newArr: any[] = []
  let arr: any[] = []
  targetArr.map((item: any) => {
    arr.push(item)
    if (arr.length % num === 0) {
      newArr.push(arr)
      arr = []
    }
  })
  if (targetArr.length % num !== 0) {
    newArr.push(targetArr.slice(targetArr.length - (targetArr.length % num)))
  }
  return newArr
}

/**
 * 判断按顺序点击按钮
 * params {string} clickFlag 控制是否能点击按钮
 * params {string} isDisabled 按钮的disabled 控制状态
 * params {boolean} enableUnlockIndex 是否需要控制不可点击
 */
export const handelClickBtn = (
  targetArr: any[],
  clickFlag: string,
  isDisabled: string,
  enableUnlockIndex: boolean
): any[] => {
  targetArr = JSON.parse(JSON.stringify(targetArr))
  targetArr.map((item: any, index: number) => {
    if (enableUnlockIndex) {
      // 第一个能点击
      if (!index) {
        targetArr[isDisabled] = false
      }
      // 第一个以后
      if (index) {
        item[isDisabled] = !targetArr[index - 1][clickFlag]
      }
    } else {
      item[isDisabled] = false
    }
  })
  return targetArr
}

export const getWeek = (date) => {
  switch (date) {
    case 1:
      return '星期一'
    case 2:
      return '星期二'
    case 3:
      return '星期三'
    case 4:
      return '星期四'
    case 5:
      return '星期五'
    case 6:
      return '星期六'
    case 0:
      return '星期日'
  }
}

export const setStorage = (k: string, v: any) => {
  const val = k !== 'token' ? JSON.stringify(v) : v
  sessionStorage.setItem(k, val)
}
export const getStorage = (k: string): any => {
  const item =
    k !== 'token'
      ? JSON.parse(
        sessionStorage.getItem(k) === 'undefined' ||
          !sessionStorage.getItem(k)
          ? '""'
          : sessionStorage.getItem(k)
      )
      : sessionStorage.getItem(k)
  return item
}

export const getQueryString = (name: string): string | null => {
  // const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "g")
  // const r = window.location.search.substr(1).match(reg)
  // if (r !== null) {
  //     return unescape(r[2])
  // }
  const reg = new RegExp('[?&]?' + name + '=([^&]*)[&$]?', 'g')
  const r = window.location.search.substr(1).match(reg)
  if (r !== null) {
    return RegExp.$1
  }
  return null
}
/**
 * url 参数序列化
 * return obj
 */
export const urlParams = (): object => {
  const index = location.href.indexOf('?')
  const params = location.href.slice(index + 1)
  const arr = params.split('&')
  const obj = {}
  arr.map((item: string) => {
    obj[item.split('=')[0]] = decodeURIComponent(item.split('=')[1])
  })
  return obj
}

/**
 * 注册端内js脚本
 * self 页面this
 */
export const registerApp = (self: any) => {
  window.lightning = self
}

/**
 * 端内返回按钮协议
 * params {object} 需要返回给端内的操作项
 */
const DefaultParams = {
  handleByHtml: true,
  url: '',
  script: '',
  protocolType: 1
}
export const titleBack = (obj: object = DefaultParams) => {
  const host = location.protocol + '//' + location.hostname
  const params = {
    handleByHtml: obj.handleByHtml || true,
    protocolEntity: {
      url: host + obj.url || '',
      script: obj.script || ''
    },
    protocolType: obj.protocolType || 1
  }
  const paramsEncode = encodeURIComponent(JSON.stringify(params))
  window.location.href = 'iss://courier/web/titleBack/' + paramsEncode
}

// 关闭h5导航栏关闭按钮，后续根据自己需求可以扩展，要考虑好兼容
export const H5CloseBtn = () => {
  // 去掉h5关闭导航栏按钮
  if (window.TitleControlJS) {
    const param = {
      back: {
        isShow: true
      },
      close: {
        isShow: false,
        toPage: '' // "recruit-progress"
      }
    }
    const titleControl = JSON.stringify(param)
    window.TitleControlJS.handleTitle(titleControl)
  }
}
// 判断安卓版本号
export const getAndroidApiLevel = (): number => {
  let num = 24
  if (window.RequestJS) {
    num = window.RequestJS.getAndroidApiLevel()
  }
  return num
}

/**
 * 单选，多选逻辑处理
 * params {object} obj 参数配置
 */
const defaultSelectParams = {
  data: [],
  isCheckbox: false,
  filtersParams: ''
}
interface SelectObj {
  data: any[]
  isCheckbox: boolean
  filtersParams: any
}
export const selectedItem = (obj: SelectObj = defaultSelectParams): any[] => {
  const arr: SelectObj = JSON.parse(JSON.stringify(obj.data))
  // 删除以选择的选项
  const removeSelected = () => {
    const index = arr.data.indexOf(arr.filtersParams)
    arr.data.splice(index, 1)
  }
  // 现在所有判断依据是选项数据源ID，如果遇到没有ID时可以改成内容，不会有影响
  if (!arr.data.includes(arr.filtersParams)) {
    // 判断多选单选
    if (arr.data.length !== 0 && !arr.isCheckbox) {
      removeSelected()
    }
    arr.data.push(arr.filtersParams)
  } else {
    removeSelected()
  }
  return arr.data
}

/**
 * 时分秒倒计时
 * params number 倒计时的时间，单位秒
 */
export const Countdown = (time: number): object => {
  const obj: object = {}
  obj.d = Math.floor(time / 1000 / 60 / 60 / 24)
  obj.h = Math.floor((time / 1000 / 60 / 60) % 24)
  obj.m = Math.floor((time / 1000 / 60) % 60)
  obj.s = Math.floor((time / 1000) % 60)
  obj.h = obj.h < 10 && obj.h > 0 ? `0${obj.h}` : obj.h
  obj.m = obj.m < 10 && obj.m > 0 ? `0${obj.m}` : obj.m
  obj.s = obj.s < 10 && obj.s > 0 ? `0${obj.s}` : obj.s
  obj.allH = Math.floor((time / 1000 / 60 / 60))
  return obj
}

export const filterArrrRepeat = (arr: any[], flag?: any) => {
  const result: any[] = []
  const obj: object = {}
  for (let i: number = 0; i < arr.length; i++) {
    if (!obj[arr[i][flag] || i]) {
      result.push(arr[i])
      obj[arr[i][flag] || i] = 1
    }
  }
  return result
}
export const getApiPrefix = () => {
  const hostname = window.location.hostname
  switch (hostname) {
    case 'm-astable.bingex.com':
      return '/as'
      break
    case 'm-bstable.bingex.com':
      return '/bs'
      break
    case 'm-cstable.bingex.com':
      return '/cs'
      break
    case 'm-dstable.bingex.com':
      return '/ds'
      break
    case 'm.ishansong.com':
      return ''
      break
    default:
      return '/cs'
      break
  }
}

export const ruleText = rule => {
  let tipsHtml = ''
  const tipsArray = (rule && rule.split(/\r\n|[\r\n]|\\n/)) || []
  tipsArray.map(tip => {
    tipsHtml = `${tipsHtml}<p class='text'>${tip}</p>`
  })
  return tipsHtml
}

export const formatTime = (date, type) => {
  if (!date) {
    return ''
  }
  const time = new Date(date)
  const y = time.getFullYear()
  const m = time.getMonth() + 1
  const d = time.getDate()
  const h = time.getHours()
  const mm = time.getMinutes()
  const s = time.getSeconds()

  switch (type) {
    case 'all':
      return (
        y +
        '-' +
        (m < 10 ? '0' + m : m) +
        '-' +
        (d < 10 ? '0' + d : d) +
        ' ' +
        (h < 10 ? '0' + h : h) +
        ':' +
        (mm < 10 ? '0' + mm : mm) +
        ':' +
        (s < 10 ? '0' + s : s)
      )
      break
    case 'ymdHm':
      return (
        y +
        '-' +
        (m < 10 ? '0' + m : m) +
        '-' +
        (d < 10 ? '0' + d : d) +
        ' ' +
        (h < 10 ? '0' + h : h) +
        ':' +
        (mm < 10 ? '0' + mm : mm)
      )
      break
    case 'ymd':
      return y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d)
      break
    case 'ymd-dot':
      return y + '.' + (m < 10 ? '0' + m : m) + '.' + (d < 10 ? '0' + d : d)
      break
    case 'ym':
      return y + '-' + (m < 10 ? '0' + m : m)
      break
    case 'ym-t':
      return y + '/' + (m < 10 ? '0' + m : m)
      break
    case 'ymd-t':
      return y + '/' + (m < 10 ? '0' + m : m) + '/' + (d < 10 ? '0' + d : d)
      break
    case 'c-ymd':
      return (
        y + '年' + (m < 10 ? '0' + m : m) + '月' + (d < 10 ? '0' + d : d) + '日'
      )
      break
    case 'c-all':
      return (
        y + '年' + (m < 10 ? '0' + m : m) + '月' + (d < 10 ? '0' + d : d) + '日' + ' ' +
        (h < 10 ? '0' + h : h) +
        ':' +
        (mm < 10 ? '0' + mm : mm) +
        ':' +
        (s < 10 ? '0' + s : s)
      )
      break
    case 'c-ym':
      return y + '年' + (m < 10 ? '0' + m : m) + '月'
      break
    case 'c-md':
      return (m < 10 ? '0' + m : m) + '月' + (d < 10 ? '0' + d : d) + '日'
      break
    case 'mdHm':
      return (
        (m < 10 ? '0' + m : m) +
        '-' +
        (d < 10 ? '0' + d : d) +
        ' ' +
        (h < 10 ? '0' + h : h) +
        ':' +
        (mm < 10 ? '0' + mm : mm)
      )
      break
    case 'mdHmChinese':
      return (
        (m < 10 ? '0' + m : m) +
        '月' +
        (d < 10 ? '0' + d : d) +
        '日' +
        (h < 10 ? '0' + h : h) +
        ':' +
        (mm < 10 ? '0' + mm : mm)
      )
      break
    case 'Hm':
      return (h < 10 ? '0' + h : h) + ':' + (mm < 10 ? '0' + mm : mm)
      break
    case 'c-Hm':
      return h + '小时' + (mm < 10 ? '0' + mm : mm) + '分钟'
      break
    default:
      return (
        y + '年' + (m < 10 ? '0' + m : m) + '月' + (d < 10 ? '0' + d : d) + '日'
      )
      break
  }
}

// 倒计时 (name==="day" 可选 xx天)  x时:x分:x秒
window.intervals = []
export const formatDateDownTime = (time, callback, name, custom) => {
  if (!time || time <= 0) {
    return (callback && callback(name === 'day' ? '0天00:00:00' : '00:00:00', true, name)) || ''
  }
  let day: number = 0 // 天
  let hour: number = 0 // 小时
  let min: number = 0 // 分钟
  let seconds: number = 0 // 秒

  if (name === 'day') {
    day = Math.floor(time / (3600 * 1000 * 24)) // 天
    const remainingTime = time - day * 3600 * 1000 * 24 // 减去天数后的剩余时间
    hour = Math.floor(remainingTime / 3600000) // 小时
    min = Math.floor((remainingTime - hour * 3600000) / 60000) // 分钟
    seconds = Math.floor((remainingTime - Math.floor(remainingTime / 60000) * 60000) / 1000) // 秒
  } else {
    hour = Math.floor(time / 3600000) // 小时
    min = Math.floor((time - hour * 3600000) / 60000) // 分钟
    seconds = Math.floor((time - Math.floor(time / 60000) * 60000) / 1000) // 秒
  }
  const s = (name === 'day' ? day ? (day + '天') : '' : '') +
    (hour < 10 ? '0' + hour : hour) +
    ':' +
    (min < 10 ? '0' + min : min) +
    ':' +
    (seconds < 10 ? '0' + seconds : seconds)
  if (callback) {
    callback(s, false, name, custom)
  }
  const downTimer = setInterval(() => {
    if (seconds > 0) {
      seconds--
    }
    if (day === 0 && seconds === 0 && min === 0 && hour === 0) {
      clearInterval(downTimer)
      return (callback && callback(name === 'day' ? '0天00:00:00' : '00:00:00', true, name, custom)) || ''
    }

    const t = (name === 'day' ? day ? (day + '天') : '' : '') +
      (hour < 10 ? '0' + hour : hour) +
      ':' +
      (min < 10 ? '0' + min : min) +
      ':' +
      (seconds < 10 ? '0' + seconds : seconds)

    if (name === 'day' && min === 0 && seconds === 0 && hour === 0 && day > 0) {
      day = day - 1
      hour = 23
      min = 59
      seconds = 60
    }
    if (seconds === 0 && min > 0) {
      min = min - 1
      seconds = 60
    }
    if (min === 0 && seconds === 0 && hour > 0) {
      hour = hour - 1
      min = 59
      seconds = 60
    }
    return (callback && callback(t, false, name, custom)) || ''
  }, 1000)
  window.intervals.push(downTimer)
}

export const loadScript = url => {
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.src = url
  document.body.appendChild(script)
}

export const loadBaiDuMapJScript = (
  callback: (BMap: any) => void,
  callbackName: string | undefined = 'BMpCallBackFunctionName'
) => {
  const BMap = window.BMap
  if (BMap) {
    callback(BMap)
    return
  }
  window[callbackName] = () => {
    callback(window.BMap)
  }
  const domain = window.location.hostname
  const ak = ['localhost', '0.0.0.0'].includes(domain)
    ? 'Ex74WzTwO4Ni4xYA8KfKog3q'
    : 'g55ZX8GEWXuuL0EWavnvtqWtGG2QiS3k'
  loadScript(
    `//api.map.baidu.com/api?v=2.0&ak=${ak}&callback=${callbackName}`
  )
}
export const highlightFirstStar = strDom => {
  return strDom ? strDom.replace(/^\*/g, '<span class="red">*</span>') : strDom
}

// 处理浮点数精度问题
export const floatObj = (num1, num2, type, digit?) => {
  /*
   * 将一个浮点数转成整数，返回整数和倍数。如 3.14 >> 314，倍数是 100
   * @param floatNum {number} 小数
   * @return {object}
   *   {times:100, num: 314}
   */
  function toInteger (floatNum) {
    const ret = { times: 1, num: 0 }
    if (!floatNum) {
      return ret
    }
    if (Math.floor(floatNum) === floatNum) {
      ret.num = floatNum
      return ret
    }
    const strfi = floatNum + ''
    const dotPos = strfi.indexOf('.')
    const len = strfi.substr(dotPos + 1).length
    const times = Math.pow(10, len)
    const intNum = parseInt(floatNum * times + 0.5, 10)
    ret.times = times
    ret.num = intNum
    return ret
  }

  /*
   * 核心方法，实现加减乘除运算，确保不丢失精度
   * 思路：把小数放大为整数（乘），进行算术运算，再缩小为小数（除）
   *
   * @param a {number} 运算数1
   * @param b {number} 运算数2
   * @param op {string} 运算类型，有加减乘除（add/subtract/multiply/divide）
   * @param digits {number} 精度，保留的小数点数，比如 2, 即保留为两位小数
   *
   */
  function operation (a, b, op, digits) {
    const o1 = toInteger(a)
    const o2 = toInteger(b)
    const n1 = o1.num
    const n2 = o2.num
    const t1 = o1.times
    const t2 = o2.times
    const max = t1 > t2 ? t1 : t2
    let result = 0
    switch (op) {
      case 'add':
        // 加法
        if (t1 === t2) {
          // 两个小数位数相同
          result = n1 + n2
        } else if (t1 > t2) {
          // o1 小数位 大于 o2
          result = n1 + n2 * (t1 / t2)
        } else {
          // o1 小数位 小于 o2
          result = n1 * (t2 / t1) + n2
        }
        return result / max
      case 'subtract':
        // 减法
        if (t1 === t2) {
          result = n1 - n2
        } else if (t1 > t2) {
          result = n1 - n2 * (t1 / t2)
        } else {
          result = n1 * (t2 / t1) - n2
        }
        return result / max
      case 'multiply':
        // 乘法
        result = (n1 * n2) / (t1 * t2)
        return result
      case 'divide':
        // 除法
        result = n1 / (n2 * t1 * t2)
        return result
    }
  }
  return operation(Number(num1), Number(num2), type, digit)
}

export const getLunarDate = timestamp => {
  const calendar = {
    gregorianYear: null, // 公历年
    gregorianMonth: null, // 公历月
    gregorianDay: null, // 公历日
    weekday: null, // 星期
    hours: null,
    minutes: null,
    seconds: null,

    lunarYear: null, // 农历年
    lunarMonth: null, // 农历月
    lunarDay: null, // 农历日

    lunarMonthCn: '', // 农历中文月
    lunarDayCn: '', // 农历中文日

    solarTerm: '', // 节气

    lunarFestival: '' // 农历节日
  }

  const lunarInfo = [
    0x04bd8,
    0x04ae0,
    0x0a570,
    0x054d5,
    0x0d260,
    0x0d950,
    0x16554,
    0x056a0,
    0x09ad0,
    0x055d2,
    0x04ae0,
    0x0a5b6,
    0x0a4d0,
    0x0d250,
    0x1d255,
    0x0b540,
    0x0d6a0,
    0x0ada2,
    0x095b0,
    0x14977,
    0x04970,
    0x0a4b0,
    0x0b4b5,
    0x06a50,
    0x06d40,
    0x1ab54,
    0x02b60,
    0x09570,
    0x052f2,
    0x04970,
    0x06566,
    0x0d4a0,
    0x0ea50,
    0x06e95,
    0x05ad0,
    0x02b60,
    0x186e3,
    0x092e0,
    0x1c8d7,
    0x0c950,
    0x0d4a0,
    0x1d8a6,
    0x0b550,
    0x056a0,
    0x1a5b4,
    0x025d0,
    0x092d0,
    0x0d2b2,
    0x0a950,
    0x0b557,
    0x06ca0,
    0x0b550,
    0x15355,
    0x04da0,
    0x0a5d0,
    0x14573,
    0x052d0,
    0x0a9a8,
    0x0e950,
    0x06aa0,
    0x0aea6,
    0x0ab50,
    0x04b60,
    0x0aae4,
    0x0a570,
    0x05260,
    0x0f263,
    0x0d950,
    0x05b57,
    0x056a0,
    0x096d0,
    0x04dd5,
    0x04ad0,
    0x0a4d0,
    0x0d4d4,
    0x0d250,
    0x0d558,
    0x0b540,
    0x0b5a0,
    0x195a6,
    0x095b0,
    0x049b0,
    0x0a974,
    0x0a4b0,
    0x0b27a,
    0x06a50,
    0x06d40,
    0x0af46,
    0x0ab60,
    0x09570,
    0x04af5,
    0x04970,
    0x064b0,
    0x074a3,
    0x0ea50,
    0x06b58,
    0x055c0,
    0x0ab60,
    0x096d5,
    0x092e0,
    0x0c960,
    0x0d954,
    0x0d4a0,
    0x0da50,
    0x07552,
    0x056a0,
    0x0abb7,
    0x025d0,
    0x092d0,
    0x0cab5,
    0x0a950,
    0x0b4a0,
    0x0baa4,
    0x0ad50,
    0x055d9,
    0x04ba0,
    0x0a5b0,
    0x15176,
    0x052b0,
    0x0a930,
    0x07954,
    0x06aa0,
    0x0ad50,
    0x05b52,
    0x04b60,
    0x0a6e6,
    0x0a4e0,
    0x0d260,
    0x0ea65,
    0x0d530,
    0x05aa0,
    0x076a3,
    0x096d0,
    0x04bd7,
    0x04ad0,
    0x0a4d0,
    0x1d0b6,
    0x0d250,
    0x0d520,
    0x0dd45,
    0x0b5a0,
    0x056d0,
    0x055b2,
    0x049b0,
    0x0a577,
    0x0a4b0,
    0x0aa50,
    0x1b255,
    0x06d20,
    0x0ada0
  ]

  const Gan = ['甲', '乙', '丙', '丁', '戊', '己', '庚', '辛', '壬', '癸']
  const Zhi = [
    '子',
    '丑',
    '寅',
    '卯',
    '辰',
    '巳',
    '午',
    '未',
    '申',
    '酉',
    '戌',
    '亥'
  ]
  const weekday = [
    '一',
    '二',
    '三',
    '四',
    '五',
    '六',
    '日'
  ]

  const now = new Date(timestamp)

  // 用于计算农历年月日的数据
  const GY = now.getFullYear()
  const GM = now.getMonth()
  const GD = now.getDate()

  const year = now.getFullYear()
  let month = now.getMonth() + 1
  let date = now.getDate()
  let hours = now.getHours()
  let minutes = now.getMinutes()
  let seconds = now.getSeconds()
  month = month.toString().padStart(2, '0')
  date = date.toString().padStart(2, '0')
  hours = hours.toString().padStart(2, '0')
  minutes = minutes.toString().padStart(2, '0')
  seconds = seconds.toString().padStart(2, '0')

  //= === 传入 offset 传回干支, 0=甲子
  function cyclical (num) {
    return Gan[num % 10] + Zhi[num % 12]
  }

  //= === 传回农历 year年的总天数
  function lYearDays (currentYear) {
    let i
    let sum = 348
    // tslint:disable-next-line: no-bitwise
    for (i = 0x8000; i > 0x8; i >>= 1) {
      // tslint:disable-next-line: no-bitwise
      sum += lunarInfo[currentYear - 1900] & i ? 1 : 0
    }
    return sum + leapDays(currentYear)
  }

  //= === 传回农历 year年闰月的天数
  function leapDays (currentYear) {
    if (leapMonth(currentYear)) {
      // tslint:disable-next-line: no-bitwise
      return lunarInfo[currentYear - 1900] & 0x10000 ? 30 : 29
    } else {
      return 0
    }
  }

  //= === 传回农历 year年闰哪个月 1-12 , 没闰传回 0
  function leapMonth (currentYear) {
    // tslint:disable-next-line: no-bitwise
    return lunarInfo[currentYear - 1900] & 0xf
  }

  //= === 传回农历 year年month月的总天数
  function monthDays (currentYear, currentMonth) {
    // tslint:disable-next-line: no-bitwise
    return lunarInfo[currentYear - 1900] & (0x10000 >> currentMonth) ? 30 : 29
  }

  //= === 算出农历, 传入日期对象, 传回农历日期对象
  //     该对象属性有 农历年year 农历月month 农历日day 是否闰年isLeap yearCyl dayCyl monCyl
  function Lunar (objDate) {
    let i
    let temp = 0
    const baseDate = new Date(1900, 0, 31)
    let offset = Math.floor((objDate - baseDate) / 86400000)

    const dayCyl = offset + 40
    let monCyl = 14

    for (i = 1900; i < 2050 && offset > 0; i++) {
      temp = lYearDays(i)
      offset -= temp
      monCyl += 12
    }
    if (offset < 0) {
      offset += temp
      i--
      monCyl -= 12
    }
    // 农历年
    const Lyear = i
    const yearCyl = i - 1864

    const leap = leapMonth(i) // 闰哪个月
    let isLeap = false // 是否闰年

    for (i = 1; i < 13 && offset > 0; i++) {
      // 闰月
      if (leap > 0 && i === leap + 1 && !isLeap) {
        --i
        isLeap = true
        temp = leapDays(Lyear)
      } else {
        temp = monthDays(Lyear, i)
      }

      // 解除闰月
      if (isLeap && i === leap + 1) {
        isLeap = false
      }

      offset -= temp
      if (!isLeap) {
        monCyl++
      }
    }

    if (offset === 0 && leap > 0 && i === leap + 1) {
      if (isLeap) {
        isLeap = false
      } else {
        isLeap = true
        --i
        --monCyl
      }
    }

    if (offset < 0) {
      offset += temp
      --i
      --monCyl
    }
    // 农历月
    const Lmonth = i
    // 农历日
    const day = offset + 1

    return {
      year: Lyear,
      month: Lmonth,
      day: day,
      isLeap: isLeap,
      leap: leap,
      yearCyl: yearCyl,
      dayCyl: dayCyl,
      monCyl: monCyl
    }
  }

  //= === 中文日期 m为传入月份，d为传入日期
  function cDay (m, d) {
    const nStr1 = [
      '日',
      '一',
      '二',
      '三',
      '四',
      '五',
      '六',
      '七',
      '八',
      '九',
      '十'
    ]
    const nStr2 = ['初', '十', '廿', '卅', '']
    // 农历中文月
    let lunarMonthCn
    // 农历中文日
    let lunarDayCn
    if (m > 10) {
      lunarMonthCn = '十' + nStr1[m - 10]
    } else {
      lunarMonthCn = nStr1[m]
    }
    lunarMonthCn += '月'

    switch (d) {
      case 10:
        lunarDayCn = '初十'
        break
      case 20:
        lunarDayCn = '二十'
        break
      case 30:
        lunarDayCn = '三十'
        break
      default:
        lunarDayCn = nStr2[Math.floor(d / 10)] + nStr1[d % 10]
    }
    return {
      lunarMonthCn: lunarMonthCn,
      lunarDayCn: lunarDayCn
    }
  }

  // 节气
  function getSolarTerm () {
    const sTermInfo = [
      0,
      21208,
      42467,
      63836,
      85337,
      107014,
      128867,
      150921,
      173149,
      195551,
      218072,
      240693,
      263343,
      285989,
      308563,
      331033,
      353350,
      375494,
      397447,
      419210,
      440795,
      462224,
      483532,
      504758
    ]
    const solarTerm = [
      '小寒',
      '大寒',
      '立春',
      '雨水',
      '惊蛰',
      '春分',
      '清明',
      '谷雨',
      '立夏',
      '小满',
      '芒种',
      '夏至',
      '小暑',
      '大暑',
      '立秋',
      '处暑',
      '白露',
      '秋分',
      '寒露',
      '霜降',
      '立冬',
      '小雪',
      '大雪',
      '冬至'
    ]

    let solarTerms = ''
    let tmp1 = new Date(
      31556925974.7 * (GY - 1900) +
      sTermInfo[GM * 2 + 1] * 60000 +
      Date.UTC(1900, 0, 6, 2, 5)
    )
    let tmp2 = tmp1.getUTCDate()
    if (tmp2 === GD) {
      solarTerms = solarTerm[GM * 2 + 1]
    }
    tmp1 = new Date(
      31556925974.7 * (GY - 1900) +
      sTermInfo[GM * 2] * 60000 +
      Date.UTC(1900, 0, 6, 2, 5)
    )
    tmp2 = tmp1.getUTCDate()
    if (tmp2 === GD) {
      solarTerms = solarTerm[GM * 2]
    }

    return solarTerms
  }

  // 公历年月日、星期、时分秒
  calendar.gregorianYear = year
  calendar.gregorianMonth = month
  calendar.gregorianDay = date
  calendar.weekday = weekday[now.getDay() > 0 ? now.getDay() - 1 : 6]
  calendar.hours = hours
  calendar.minutes = minutes
  calendar.seconds = seconds

  // 去掉时分秒的日期
  const sDObj = new Date(GY, GM, GD)
  const lDObj = new Lunar(sDObj)

  // 农历年月日、生肖年
  calendar.lunarYear = lDObj.year
  calendar.lunarMonth = lDObj.month
  calendar.lunarDay = lDObj.day

  // 农历中文年月日
  calendar.lunarMonthCn = cDay(lDObj.month, lDObj.day).lunarMonthCn
  calendar.lunarDayCn = cDay(lDObj.month, lDObj.day).lunarDayCn

  // 节气
  calendar.solarTerm = getSolarTerm()

  return calendar
}

export const getOssDomain = () => {
  const hostname = window.location.hostname
  const ossDomain = { svDomain: '', imgDomain: '' }
  switch (hostname) {
    case 'm-sf.bingex.com':
      ossDomain.svDomain = 'https://file-sf.bingex.com'
      ossDomain.imgDomain = 'https://cdn-file.ishansong.com'
      break

    case 'm-astable.bingex.com':
      ossDomain.svDomain = 'https://file-astable.bingex.com'
      ossDomain.imgDomain = 'https://cdn-file.ishansong.com'
      break

    case 'm-bstable.bingex.com':
      ossDomain.svDomain = 'https://file-bstable.bingex.com'
      ossDomain.imgDomain = 'https://cdn-file.ishansong.com'
      break

    case 'm-cstable.bingex.com':
      ossDomain.svDomain = 'https://file-cstable.bingex.com'
      ossDomain.imgDomain = 'https://cdn-file.ishansong.com'
      break

    case 'm-dstable.bingex.com':
      ossDomain.svDomain = 'https://file-dstable.bingex.com'
      ossDomain.imgDomain = 'https://cdn-file.ishansong.com'
      break

    case 'm.ishansong.com':
      ossDomain.svDomain = 'https://fileapi.ishansong.com'
      ossDomain.imgDomain = 'https://cdn-file.ishansong.com'
      break
    default:
    //   ossDomain.svDomain = 'http://m-stable-22145621.fat.bingex.com'
    //   ossDomain.imgDomain = 'http://m-stable-22145621.fat.bingex.com'
      ossDomain.svDomain = '//file-cstable.bingex.com'// 'https://fileapi.ishansong.com'
      ossDomain.imgDomain = 'hhttps://cdn-file.ishansong.com'
      break
  }
  return ossDomain
}

/*
  * 处理列表数组形式的倒计时，通过动态设置dom ID名字，修改dom内容
  * @param timerName {string} 倒计时timer的名字
  * @param time {number} 倒计时的差值毫秒值
  * @param num {num}  循环到第几个索引，用于动态赋值dom ID名字
  * @param domStr {string} 用于动态赋值dom ID名字的前缀，由外边控制
  * @return {string} 为空字符串，用于兼容处理ts警告
  * @onComplete {function} 倒计时结束的回调函数
  * @onTimer {function} 每次倒计时的回调函数, 返回数值有dom对象和计算的差值
  */
export const handelArrTimerServer = (domStr: string, timerName: any, time: number, num: number, onTimer: any, onComplete?: any) => {
  function countTime (fn: any) {
    let timer: any = null
    if (!time) {
      return
    }
    timer = timerName
    clearInterval(timer)
    fn(time)
    timer = setInterval(() => {
      time -= 1000
      if (time <= 0) {
        clearInterval(timer)
        if (onComplete) {
          onComplete()
        }
      } else {
        fn(time)
      }
    }, 1000)
    window.intervals.push(timer)
  }
  setTimeout(() => {
    countTime(msg => {
      const dom: any = document.getElementById(`${domStr}${num}`)
      if (dom) {
        // const str = `${Moment.duration(msg).days()}天${Moment
        // 	.duration(msg)
        // 	.hours()}:${Moment.duration(msg).minutes()}:${Moment
        // 	.duration(msg)
        // 	.seconds()}`
        if (onTimer) {
          onTimer(dom, Moment.duration(msg))
        }
        // dom.innerHTML = `还剩<span style='min-width: 1.01rem;
        // 										display: inline-block'>${str}</span>`
      }
    })
  })
  return ''
}

export const addSearchParams = (url: any): any => {
  let urlSearch = window.location.search
  if (urlSearch) {
    urlSearch += (url ? `&${url}` : '')
  } else {
    urlSearch += (url ? `?${url}` : '')
  }
  return urlSearch
}

/*
  * 格式化金额显示，浮点数精确到小数点后两位，整数直接显示
  * @param money {number} 金额【单位:分】
  */
export const formatMoney = (money: number): string => {
  const formatedMoney = String(money * 0.01)
  if (parseInt(formatedMoney, 0) === parseFloat(formatedMoney)) {
    return parseInt(formatedMoney, 0).toFixed(0)
  } else {
    return parseFloat(formatedMoney).toFixed(2)
  }
}
